import React from "react";
import tw, { styled } from "twin.macro";

const Div = styled.div(({ animate }) => [
  tw`text-gold md:text-5xl xl:text-6xl flex text-4xl duration-1000 ease-in-out`,
  animate === false && tw`blur-sm opacity-0`,
  animate === true && tw`blur-0 opacity-100`,
]);

const Stars = ({ amount, ...rest }) => {
  if (!amount) amount = 5;
  return (
    <Div
      {...rest}
      dangerouslySetInnerHTML={{
        __html: new Array(amount + 1).fill().join("&starf;"),
      }}
    />
  );
};

export default Stars;
